<template>
  <div class="pages">
    <div class="printArea" ref="printArea">
      <el-descriptions style="text-align: center;margin: 2rem 0;" :title="$t('main.OrderingInformation')">
        <el-descriptions-item :label="$t('main.OrderNumber')">{{orderInfo.sn}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.OrderDate')">{{ handleTimeToString(orderInfo.create_time) }}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.totalNum')">{{ orderInfo.total_number }}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.amountOfMoney')" v-if="orderInfo.order_type==='1'">{{ $t('main.monetaryUnit') }}{{ (Math.round( (parseFloat(orderInfo.total_price) + parseFloat(orderInfo.freight_price)) * 100)/100).toFixed(2) }}({{ $t('main.IncludingShippingFreight') }}{{ $t('main.monetaryUnit') }}{{ orderInfo.freight_price }})</el-descriptions-item>
        <el-descriptions-item :label="$t('main.ProductType')">{{ orderInfo.order_type === '1' ? $t('main.OnlineProducts') : $t('main.productBuild') }}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.Status')" v-if="orderInfo.order_type==='1' && orderInfo.pay_type!=='4'">
          <span v-if="orderInfo.status==='0'">{{ $t('main.ToBePaid') }}</span>
          <span v-if="orderInfo.status==='1'">{{ $t('main.ToBeShipped') }}</span>
          <span v-if="orderInfo.status==='2'">{{ $t('main.ToBeReceived') }}</span>
          <span v-if="orderInfo.status==='4'">{{ $t('main.Completed') }}</span>
          <span v-if="orderInfo.status==='8'">{{ $t('main.HasDeleted') }}</span>
          <span v-if="orderInfo.status==='9'">{{ $t('main.Cancelled') }}</span>

          <el-button
              v-if="orderInfo.status == '0' && orderInfo.order_type==='1'"
              class="operatespan"
              @click="detailOrder(0, orderInfo.sn)"
              type="danger"
          >
            {{ $t('main.PayNow') }}
          </el-button>
          <el-button
              v-if="orderInfo.status == '0' && orderInfo.order_type==='1'"
              class="operatespan"
              @click="detailOrder(1, orderInfo.sn)"
              type="danger"
          >
            {{ $t('main.delete') }}
          </el-button>

          <!-- {{ orderInfo.status }}  "0|未支付,1|已支付，未发货,2|已发货，未收货,3|已收货，未评价,4|已评价，已完成,8|已删除,9|已取消", -->
          <!-- <font style="color:#635796;">处理：去支付/确认收货/删除/取消</font> -->
        </el-descriptions-item>
        <el-descriptions-item :label="$t('main.ViewContract')" v-if="orderInfo.order_type==='1'">
          <a :href="hetongaddress" class="cBtn" style="padding: 6px 20px;" target="_blank">{{ $t('main.ViewContract') }}</a>
          <!-- {{ orderInfo.contract_id }} -->
          <!-- <font >处理：查看合同跳转</font> -->
        </el-descriptions-item>
        <el-descriptions-item :label="$t('main.ViewQuotation')" v-if="orderInfo.order_type==='1'">
          <a :href="orderInfo.quotation_href" class="cBtn" style="padding: 6px 20px;" target="_blank">{{ $t('main.ViewQuotation') }}</a>
          <!-- {{ orderInfo.contract_id }} -->
          <!-- <font >处理：查看合同跳转</font> -->
        </el-descriptions-item>
        <el-descriptions-item :label="$t('main.remark')">{{ orderInfo.note_message }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions v-if="orderInfo.address_id" style="text-align: center;margin: 2rem 0;" :title="$t('main.ConsigneeInformation')">
        <el-descriptions-item :label="$t('main.receiver')">{{orderInfo.address_info.receive_user}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.telephone')">{{orderInfo.address_info.receive_phone}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.country')">{{orderInfo.address_info.country}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.city')">{{orderInfo.address_info.city}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.orderCompany')">{{orderInfo.address_info.receive_company}}</el-descriptions-item>
        <el-descriptions-item v-if="orderInfo.site_id == 1" :label="$t('main.addressDetail')">{{orderInfo.address_info.receive_address}}</el-descriptions-item>
        <el-descriptions-item v-if="orderInfo.site_id != 1" :label="$t('main.AddressLine1')">{{orderInfo.address_info.receive_address}}</el-descriptions-item>
        <el-descriptions-item v-if="orderInfo.site_id != 1" :label="$t('main.AddressLine2')">{{orderInfo.address_info.receive_address_2}}</el-descriptions-item>
        <el-descriptions-item v-if="orderInfo.site_id != 1" :label="$t('main.AddressLine3')">{{orderInfo.address_info.receive_address_3}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions v-if="orderInfo.logistics_numbers" style="text-align: center;margin: 2rem 0;" :title="$t('main.LogisticsInformation')">
        <el-descriptions-item :label="$t('main.LogisticsCompany')">{{orderInfo.logistics_company}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.LogisticsNumber')">{{orderInfo.logistics_numbers}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.deliveryTime')">{{handleTimeToString(orderInfo.logistics_time)}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions v-if="orderInfo.bill_id" style="text-align: center;margin: 2rem 0;" :title="$t('main.Invoice')">
        <el-descriptions-item v-if="orderInfo.site_id == 1" :label="$t('main.InvoiceType')">{{ orderInfo.bill_type=='1' ? $t('main.PlainInvoice') : $t('main.SpecialInvoice') }}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.receiver')">{{orderInfo.bill_info.receive_user}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.telephone')">{{orderInfo.bill_info.receive_phone}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.receiveEmail')">{{orderInfo.bill_info.receive_email}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.country')">{{orderInfo.bill_info.country}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.city')">{{orderInfo.bill_info.city}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.Company')">{{orderInfo.bill_info.name}}</el-descriptions-item>
        <el-descriptions-item :label="$t('main.TaxpayerIdentificationNumber')">{{orderInfo.bill_info.number}}</el-descriptions-item>
        <el-descriptions-item v-if="orderInfo.site_id == 1 && orderInfo.bill_info.company_type == 1" :label="$t('main.CompanyAddress')">{{orderInfo.bill_info.address}}</el-descriptions-item>
        <el-descriptions-item v-if="orderInfo.site_id == 1 && orderInfo.bill_info.company_type == 1" :label="$t('main.BankName')">{{orderInfo.bill_info.bank_name}}</el-descriptions-item>
        <el-descriptions-item v-if="orderInfo.site_id == 1 && orderInfo.bill_info.company_type == 1" :label="$t('main.BankAccount')">{{orderInfo.bill_info.bank_number == 0 ? '/':orderInfo.bill_info.bank_number}}</el-descriptions-item>
        <el-descriptions-item v-if="orderInfo.site_id == 1 && orderInfo.bill_info.company_type == 1" :label="$t('main.CompanyPhone')">{{orderInfo.bill_info.phone}}</el-descriptions-item>
        <el-descriptions-item v-if="!(orderInfo.site_id == 1 && orderInfo.bill_info.company_type == 1)" :label="$t('main.AddressLine1')">{{orderInfo.bill_info.address}}</el-descriptions-item>
        <el-descriptions-item v-if="!(orderInfo.site_id == 1 && orderInfo.bill_info.company_type == 1)" :label="$t('main.AddressLine2')">{{orderInfo.bill_info.address_2}}</el-descriptions-item>
        <el-descriptions-item v-if="!(orderInfo.site_id == 1 && orderInfo.bill_info.company_type == 1)" :label="$t('main.AddressLine3')">{{orderInfo.bill_info.address_3}}</el-descriptions-item>
      </el-descriptions>
      <el-table
          :data="tableData"
          border
          style="width: 100%;margin:2rem 0;">
        <el-table-column type="index" :label="$t('main.Item')" width="60"></el-table-column>
        <el-table-column
            header-align="center"
            class="fac"
            prop="product_data"
            :label="$t('main.ProductSpecifications')"
            min-width="500">
          <template slot-scope="scope">
            <div class="fac td-label">
              <img style="cursor: pointer;" @click="gotoProductDetail(scope.row)" :src="scope.row.thumb" class="pImg" />
              <div class="ml20">
                <div class="fac" v-if="orderInfo.order_type==='1'">
                  <div style="width: 12rem">{{ $t('main.product') }}</div>
                  <div style="width: calc(100% - 12rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(scope.row)">{{ scope.row.type_name }}</div>
                </div>
                <div class="fac">
                  <div v-if="orderInfo.order_type==='1'" style="width: 12rem">{{ $t('main.partNumber') }}</div>
                  <div v-if="orderInfo.order_type==='1'" @click="gotoProductDetail(scope.row)" style="width: calc(100% - 12rem);cursor: pointer;color: #635796;">{{ scope.row.product_model }}</div>
                  <div v-if="orderInfo.order_type==='2'" style="width: 12rem">{{ $t('main.productBuild') }}</div>
                  <div v-if="orderInfo.order_type==='2'" @click="gotoProductDetail(scope.row)" style="width: calc(100% - 12rem);cursor: pointer;color: #635796;">{{ scope.row.type_name }}</div>
                </div>
                <div class="fac color-999" v-for="(hobby, index) in scope.row.product_data" v-if="hobby.isShow" :key="index">
                  <div style="width: 12rem">{{ hobby.title }}</div>
                  <div style="width: calc(100% - 12rem);">{{ hobby.value }}</div>
                </div>
                <div class="fac color-999" v-for="(hobby, index) in scope.row.product_data" v-if="orderInfo.order_type==='2' || (!hobby.isShow && showMore.findIndex(res=>{return res == scope.id;}) > -1)" :key="index">
                  <div style="width: 12rem">{{ hobby.title }}</div>
                  <div style="width: calc(100% - 12rem);">{{ hobby.value }}</div>
                </div>
                <div v-if="orderInfo.order_type==='1'" class="fac color-635796" style="cursor: pointer;" @click="handleProductParamsMore(scope)">
                  {{ showMore.findIndex(res=>{return res == scope.id;}) > -1 ? $t('main.Cut') : $t('main.More') }}
                  <i :class="showMore.findIndex(res=>{return res == scope.id;}) > -1 ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="price"
            v-if="orderInfo.order_type==='1'"
            align='center'
            min-width="100"
            :label="$t('main.priceForOne')">
        </el-table-column>

        <el-table-column
            prop="number"
            align='center'
            min-width="100"
            :label="$t('main.totalNum')">
        </el-table-column>

        <el-table-column
            prop="_price"
            v-if="orderInfo.order_type==='1'"
            align='center'
            min-width="100"
            :label="$t('main.totalPrice')">

          <template slot-scope="scope">
            <p>{{ $t('main.monetaryUnit') }}{{ Math.round( scope.row.price*scope.row.number * 100)/100 }}<br/></p>

          </template>


        </el-table-column>
        <el-table-column
            v-if="orderInfo.order_type==='1'"
            align='center'
            prop="_gouwuche"
            min-width="180"
            :label="$t('main.RepeatOrder')">

          <template slot-scope="scope">
         <el-input-number v-model="scope.row.inputValue" :min="1" placeholder="1" style="margin-bottom:10px" ></el-input-number>
            <el-button
                class="mb20 addShopCarForGoogle"
                @click="addGoodToCard(scope.row)"
                type="danger"
            >
              {{ $t('main.addShopCar') }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
            v-if="orderInfo.order_type==='2'"
            align='center'
            prop="_gouwuche"
            min-width="180"
            :label="$t('main.RepeatOrder')">

          <template slot-scope="scope">
            <el-input-number v-model="numbershop" :min="1" style="margin-bottom:10px"></el-input-number>
            <!--处理定制-->
            <el-button
                class="mb20"
                type="danger"
                @click="handleSubmitCustom(scope.row)"
            >
              {{ $t('main.commit') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {listDetailOrder, getUserInfo, deleteOrder, cancelgood, suregetGood} from "@/api/order";
import countryList from "@/api/country.json"
import { getHetong } from "@/api/order";
import Cookie from 'js-cookie';
import { addShopcar} from "@/api/shopcar";
import Cookies from "js-cookie";
import {getProductInfo} from "@/api";
export default {
  data() {
    return {
      tableData: [],
      orderInfo:{},
      countryList: [],
      currentUserInfo:{},//当前用户信息
      tableInfo:[],//表格信息
      ordreStatus:"",
      hetongaddress:"",
      numbershop:1,
      showMore: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  watch: {
    "$store.state.siteInfo":  function(newV, oldV) {
      if (newV && typeof oldV != 'object') {
        this.$router.push({ path: "/userCenter"});
      }
    }
  },
  created(){
    this.getOrderDetailfun(this.$route.query.id);
    const country = [];
    Object.assign(country, countryList);
    this.countryList = country;
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    detailOrder(flag, sn){
      if(0==flag){
        //去支付
        this.$router.push({ path: '/purchase', query: { sn:sn } })
      }
      if(1==flag){
        //删除
        var params = {
          req: {
            sns: sn,
          },
        }
        this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
          confirmButtonText: this.$t('main.sure'),
          cancelButtonText: this.$t('main.cancel'),
          type: 'warning',
        })
            .then(() => {
              deleteOrder(params).then((res) => {
                if (res.rsp.code == 0) {
                  this.init()
                  this.$message({
                    message: this.$t('main.operationCompletedSuccessfully'),
                    type: 'success',
                  })
                } else {
                  this.$message({
                    message: res.rsp.msg,
                    type: 'error',
                  })
                }
              })
            })
            .catch(() => {})
      }

      if(2==flag){
        // 取消
        var params = {
          req: {
            sns: sn,
          },
        }

        var params = {
          req: {
            sns: sn,
          },
        }
        this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
          confirmButtonText: this.$t('main.sure'),
          cancelButtonText: this.$t('main.cancel'),
          type: 'warning',
        })
            .then(() => {
              cancelgood(params).then((res) => {
                if (res.rsp.code == 0) {
                  this.init()
                  this.$message({
                    message: this.$t('main.operationCompletedSuccessfully'),
                    type: 'success',
                  })
                } else {
                  this.$message({
                    message: res.rsp.msg,
                    type: 'error',
                  })
                }
              })
            })
            .catch(() => {})
        //取消
      }
      if(3==flag){
        //确认收货
        var params = {
          req: {
            sns: sn,
          },
        }
        this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
          confirmButtonText: this.$t('main.sure'),
          cancelButtonText: this.$t('main.cancel'),
          type: 'warning',
        })
            .then(() => {
              suregetGood(params).then((res) => {
                if (res.rsp.code == 0) {
                  this.init()
                  this.$message({
                    message: this.$t('main.operationCompletedSuccessfully'),
                    type: 'success',
                  })
                } else {
                  this.$message({
                    message: res.rsp.msg,
                    type: 'error',
                  })
                }
              })
            })
            .catch(() => {})
      }
    },
    //到产品界面
    gotoProductDetail(item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
            query: {
              keyword: item.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    handleProductParamsMore(item) {
      let isExit = this.showMore.findIndex(res=>{
        return res == item.id;
      });
      if (isExit > -1) {
        this.showMore.splice(isExit, 1);
      } else {
        this.showMore.push(item.id);
      }
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    addGoodToCard(item) {
      let params = {
        req: {
          product_ids: [
            {
              product_id: item.id,
              number: item.inputValue  || 1
            }
          ]
        }
      };
      addShopcar(params).then(res => {
        if (res.rsp.code === 0) {
          this.$store.dispatch("setCarNum", true);
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          });
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error',
          })
        }
      });
    },
    // 提交定制产品
    handleSubmitCustom(item) {
      let productInfo = item.product_data.map(i => {
        return {
          title: i.title,
          value: item[i.varname]
        };
      });
      window.sessionStorage.setItem("settlementInfo", JSON.stringify({
        product_info: productInfo,
        number: this.numbershop || 1,
        totalNumber: this.numbershop || 1,
        productimg: item.thumb,
        resource: "custom",
        type_id: item.type_id,
        customForm: item
      }));
      this.$router.push({
        path: "/addressInformation"
      });
    },
    getOrderDetailfun(id){
      const params = {
        "req": {
          "sn": id
        }
      };
      listDetailOrder(params).then((res)=>{
        if(res.rsp.code==0){
          this.orderInfo = res.data;
          const addressCountry = this.countryList.filter(
              item => item.ab == this.orderInfo.address_info.country
          );
          const billCountry = this.countryList.filter(
              item => item.ab == this.orderInfo.bill_info.country
          );
          if (this.orderInfo.site_id == 1) {
            this.orderInfo.address_info.country = addressCountry[0].country_name_cn;
            this.orderInfo.bill_info.country = billCountry[0].country_name_cn;
          } else {
            this.orderInfo.address_info.country = addressCountry[0].country_name_en;
            this.orderInfo.bill_info.country = billCountry[0].country_name_en;
          }

          this.tableData = res.data.sn_product_list;
          this.tableInfo = this.tableData.map((item) => {
            item.product_data.map((product)=> {
              item[product.varname] = product.value
            })
          });
          this.getHetonginf(this.orderInfo.contract_id);
          var userParams = {
            "req": {
              "id": res.data.user_id
            }
          }
          getUserInfo(userParams).then((resu)=>{
            this.currentUserInfo = resu.data;
            this.$forceUpdate();
          })
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },

    getHetonginf(htid){
      var params =  {
        "req": {
          "id": htid
        }
      }
      getHetong(params).then((res) => {
        // console.log("结算请求后回来的数据", res);
        this.hetongaddress = res.data.contract_url;
        // this.$router.push({ path: "/purchase", query: this.paramsToOrder });
      });
    },

    goToMore() {
      this.$router.push("/more");
    },
    formatStatus(row){
      //console.log("rowrow");
      //console.log(row);
      // if(row.product_type ===1){
      //     return "标准产品"
      // }else{
      //     return "常用产品"
      // }

    },

    print(){
      // console.log("打印");
      const printArea = this.$refs.printArea;
      const printWindow = window.open('', '_blank');
      printWindow.document.write(printArea.innerHTML);
      printWindow.document.close();
      // 调用打印程序
      printWindow.print();
      printWindow.close();

    },
    handleTimeToString(v) {
      // let date = new Date(parseInt(v) - 1000);
      // let Y = date.getFullYear();
      // let M = date.getMonth() + 1;
      // let D = date.getDate();
      // let H = date.getHours();
      // let m = date.getMinutes();
      // let s = date.getSeconds();
      // return `${Y}-${M}-${D} ${H}:${m}:${s}`;
      var chazhi = Cookies.get("Difference");
      var benditime = v*1000-chazhi;
      let date = new Date(benditime);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      M = M > 9 ? M : "0" + M;
      let D = date.getDate();
      D = D > 9 ? D : "0" + D;
      let H = date.getHours();
      H = H > 9 ? H : "0" + H;
      let m = date.getMinutes();
      m = m > 9 ? m : "0" + m;
      let s = date.getSeconds();
      s = s > 9 ? s : "0" + s;
      return `${Y}-${M}-${D} ${H}:${m}:${s}`;
    }
  }
};
</script>

<style scoped lang="less">
.operatespan{
  padding: 5px 10px;
  margin-left: 5px;
}
.pages {
  min-height: 100%;
  background-color: #fff;
}
.color-999 {
  color: #999999;
}
.ml20 {
  margin-left: 0.5rem;
}
.pImg {
  width: 7.5rem;
}
.td-label {
  text-align: left;
}

.cBtn {
  background-color: #635796;
  border-color: #635796;
  padding: 5px 10px;
  margin-left: 5px;
  color: #FFF;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  transition: .1s;
  font-weight: 500;
  font-size: 14px;
  border-radius: 4px;
}
/deep/ .el-descriptions__header{
  text-align: center;

}
/deep/ .el-table .cell{
  text-align: center;
  line-height: unset;
}
/deep/ .el-table .cell p{
  margin: 0;
}
/deep/ .el-button--danger {
  background-color: #635796;
  border-color: #635796;
}
/deep/ .el-input-number {
  display: block;
  margin: 0 auto;
}
/deep/ .el-input-number__decrease,
/deep/ .el-input-number__increase {
  bottom: 1px;
}
@media screen and (max-width: 1400px) {
  .printArea {
    padding: 0 2%;
  }
}
@media screen and (min-width: 1400px) {
  .printArea {
    padding: 0 10%;
  }
}
@media screen and (min-width: 1700px) {
  .printArea {
    padding: 0 15%;
  }
}
</style>
